import React, { useState } from "react";
import { i18n } from "../../translate/i18n";
import { Avatar, CardHeader, Grid, TextField, Input, InputAdornment, InputLabel } from "@material-ui/core";
import { TagsKanbanContainer } from "../TagsKanbanContainer";
import { getBackendUrl } from "../../config";

const TicketInfo = ({ contact, ticket, onClick }) => {
	const [amount, setAmount] = useState("");
	const backendUrl = getBackendUrl();
	const userAvatarSrc = ticket?.user?.profileImage
		? `${backendUrl}/public/company${ticket.user.companyId}/user/${encodeURIComponent(ticket.user.profileImage)}?v=${encodeURIComponent(ticket.user.updatedAt || ticket.user.profileImage)}`
		: null;

	const renderCardReader = () => {
		return (
			<CardHeader
				onClick={onClick}
				style={{ cursor: "pointer" }}
				titleTypographyProps={{ noWrap: true }}
				subheaderTypographyProps={{ noWrap: true }}
				avatar={<Avatar src={contact?.urlPicture} alt="contact_image" />}
				title={`${contact?.name || i18n.t("tickets.noContactName")} #${ticket.id}`}
				subheader={
					ticket.user &&
					(
						<span style={{ display: "inline-flex", alignItems: "center", gap: 6 }}>
							<Avatar src={userAvatarSrc} alt={ticket.user.name} style={{ width: 20, height: 20 }} />
							<span>{`${i18n.t("messagesList.header.assignedTo")} ${ticket.user.name}`}</span>
						</span>
					)
				}

			/>
		);
	}

	const handleChange = (event) => {
		const value = event.target.value;

		setAmount(value);
	}


	return (
		<React.Fragment>
			<Grid container alignItems="center" spacing={10}>
				{/* Conteúdo do contato à esquerda */}
				<Grid item xs={6}>
					{renderCardReader()}
				</Grid>
			</Grid>
		</React.Fragment>
	);
};

export default TicketInfo;
